import { TRAILER_LOAD_MODE } from '../constants';

export enum BORDER_PASS_EASY_WITH_LE_SHUTTLE_FREIGHT {
  EMPTY = '14721efb-7133-4605-bc5c-217cbe907f71',
  FULL = '5b592467-f591-4c1b-8bfb-777f4c258df0',
}

export enum OPEN_CUSTOMS_AND_CROSSING {
  CUSTOMS_PASS = 'a83395b7-4094-4819-a03c-ea5bf6b147a0',
  BORDER_CROSSING_RORO = '42139f39-c98d-4426-8d91-b4d488d8117e',
  BORDER_CROSSING_RORO_EMPTY_V2 = '56bee7f8-3e94-434b-beac-550353763b97',
}

const openCustomsAndCrossingIds = Object.values(OPEN_CUSTOMS_AND_CROSSING).map(String);

export const isBorderPassEasyWithLeShuttleFreightFull = ({ folderTypologyId }: { folderTypologyId: string }) =>
  folderTypologyId === BORDER_PASS_EASY_WITH_LE_SHUTTLE_FREIGHT.FULL;

export const isBorderPassEasyWithLeShuttleFreightEmpty = ({ folderTypologyId }: { folderTypologyId: string }) =>
  folderTypologyId === BORDER_PASS_EASY_WITH_LE_SHUTTLE_FREIGHT.EMPTY;

export const isOpenCustomsAndCrossing = ({ folderTypologyId }: { folderTypologyId: string }) =>
  openCustomsAndCrossingIds.includes(folderTypologyId);

export const isCustomPass = ({ folderTypologyId }: { folderTypologyId: string }) =>
  folderTypologyId === OPEN_CUSTOMS_AND_CROSSING.CUSTOMS_PASS;

export const isBorderCrossingRoRo = ({ folderTypologyId }: { folderTypologyId: string }) =>
  folderTypologyId === OPEN_CUSTOMS_AND_CROSSING.BORDER_CROSSING_RORO;

export const isBorderCrossingRoRoEmptyV2 = ({ folderTypologyId }: { folderTypologyId: string }) =>
  folderTypologyId === OPEN_CUSTOMS_AND_CROSSING.BORDER_CROSSING_RORO_EMPTY_V2;

export const checkIsTrailerLoadModeEmpty = ({ trailerLoadMode }: { trailerLoadMode: TRAILER_LOAD_MODE }) =>
  trailerLoadMode === TRAILER_LOAD_MODE.EMPTY;

export const checkIsTrailerLoadModeFull = ({ trailerLoadMode }: { trailerLoadMode: TRAILER_LOAD_MODE }) =>
  trailerLoadMode === TRAILER_LOAD_MODE.FULL;
